export { default as MainFloat } from './mainfloat'
export { default as Margins } from './margins'
export { default as Page } from './page'
export { default as Topper } from './topper'
export { default as Btn } from './btn'
export { default as LinkText } from './link'
export { default as RichText } from './richText'
export { default as Outer } from './outer'
export { default as Centred } from './centred'
export { default as Contents } from './contents'
export { default as Develop } from './gradients/develop'
export { default as Devops } from './gradients/devops'
export { default as Dynamics } from './gradients/dynamics'
export { default as Studies } from './gradients/studies'
export { default as Blog } from './gradients/blog'
export { default as Careers } from './gradients/careers'
export { default as About } from './gradients/about'
export { default as Contact } from './gradients/contact'



// WEBPACK FOOTER //
// ./src/styles/mixins/index.js